<script setup lang="ts">
const { global } = useGlobalData();
const { t } = useI18n();

const { cookie: cookieConsent, hasAnswered } = useCookieConsent();
const { notifyAnalyticsConsentAccepted } = useTracking();

const acceptAllCookies = async () => {
    cookieConsent.value = '1';
    await nextTick();
    await notifyAnalyticsConsentAccepted();
};

const acceptOnlyEssentialCookies = () => {
    cookieConsent.value = '0';
};
</script>

<template>
    <ClientOnly>
        <div v-if="!hasAnswered">
            <div
                class="fixed bottom-4 left-0 right-0 bg-zinc-200 border border-zinc-200 z-50 mx-4 lg:mx-auto max-w-5xl flex flex-col md:flex-row shadow-lg rounded-lg p-4 justify-between gap-4"
            >
                <div class="text-gray-700 w-full md:w-2/3 flex items-center">
                    {{ t('footer.cookies.message') }}
                </div>
                <div class="justify-center items-center flex gap-2">
                    <UButton
                        variant="outline"
                        size="lg"
                        color="info"
                        class="w-full cursor-pointer whitespace-nowrap justify-center h-fit bg-white"
                        @click="acceptOnlyEssentialCookies"
                        >{{ t('footer.cookies.acceptOnlyEssential') }}</UButton
                    >
                    <UButton
                        variant="solid"
                        size="lg"
                        color="success"
                        class="w-full cursor-pointer whitespace-nowrap justify-center h-fit"
                        @click="acceptAllCookies"
                        >{{ t('footer.cookies.acceptAll') }}</UButton
                    >
                </div>
            </div>
        </div>
    </ClientOnly>
    <footer class="bg-zinc-100 text-offblue-800 py-12 w-full mt-auto">
        <div class="container mx-auto px-4">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
                <div>
                    <img src="~/assets/img/RadiMed_2tone.svg" alt="Logo" class="w-60 h-20" />
                </div>
                <div class="flex flex-col gap-4">
                    <h3 class="text-2xl font-heading text-offblue-600">{{ t('footer.contacts') }}</h3>
                    <div class="flex flex-col gap-2">
                        <p v-if="global?.office_address" class="flex items-center gap-2">
                            <UIcon name="i-heroicons-map-pin" class="text-office-400" />
                            <span>{{ t('footer.address') }} {{ global.office_address }}</span>
                        </p>
                        <p v-if="global?.office_phone" class="flex items-center gap-2">
                            <UIcon name="i-heroicons-phone" class="text-office-400" />
                            <span>{{ t('footer.phone') }} {{ global.office_phone }}</span>
                        </p>
                        <p v-if="global?.office_email" class="flex items-center gap-2">
                            <UIcon name="i-heroicons-envelope" class="text-office-400" />
                            <span>{{ t('footer.email') }} {{ global.office_email }}</span>
                        </p>
                    </div>
                </div>
                <div v-if="global?.opening_hours || global?.translations[0]?.opening_hours" class="flex flex-col gap-4">
                    <h3 class="text-2xl font-heading text-offblue-600">{{ t('footer.openingHours') }}</h3>
                    <div class="flex flex-col gap-2">
                        <div v-html="global?.translations[0]?.opening_hours || global?.opening_hours" />
                    </div>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <div class="ml-auto mt-auto">
                        <NuxtLink to="/partners">
                            <UButton
                                color="secondary"
                                variant="solid"
                                size="md"
                                icon="i-heroicons-user"
                                class="cursor-pointer"
                            >
                                Partneriem
                            </UButton>
                        </NuxtLink>
                    </div>
                </div>
            </div>
            <div class="mt-8 pt-8 border-t border-offblue-700 text-center text-offblue-700">
                <p>
                    &copy; {{ new Date().getFullYear() }} {{ global?.translations[0]?.title || global?.title }}.
                    {{ t('footer.copyright') }}
                </p>
            </div>
        </div>
    </footer>
</template>
